"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _guessCountryFromDialCode = _interopRequireDefault(require("I18n/utils/guessCountryFromDialCode"));

var _formatPhoneNumber = _interopRequireDefault(require("I18n/utils/formatPhoneNumber"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _CountryFlag = _interopRequireDefault(require("../internal/components/CountryFlag"));

var _getPhoneOptions = _interopRequireDefault(require("../internal/utils/getPhoneOptions"));

var _SupportedPhoneNumbers = _interopRequireDefault(require("../constants/SupportedPhoneNumbers"));

var TelephoneData = _interopRequireWildcard(require("I18n/constants/TelephoneData"));

var allCountries = TelephoneData.allCountries;
var iso2Lookup = TelephoneData.iso2Lookup;
var INVALID_OPTION = {
  dialCode: '',
  priority: 10001,
  iso2: null
};

var _default = (0, _createReactClass.default)({
  displayName: "PhoneNumberInput",
  propTypes: {
    countrySelectProps: _propTypes.default.object,
    extensionInputProps: _propTypes.default.object,
    extensionValue: _propTypes.default.string,
    onChange: _propTypes.default.func,
    phoneInputProps: _propTypes.default.object,
    supportedCountrySet: _propTypes.default.oneOf(Object.keys(_SupportedPhoneNumbers.default)),
    validCountries: _propTypes.default.array,
    value: _propTypes.default.string
  },
  getDefaultProps: function getDefaultProps() {
    return {
      countrySelectProps: {},
      extensionInputProps: {},
      phoneInputProps: {}
    };
  },
  getInitialState: function getInitialState() {
    return this._mapPropsToState(this.props);
  },
  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.value === null || nextProps.value === undefined) {
      this.setState(this._mapPropsToState(nextProps));
    } else {
      var nextValueDigits = nextProps.value.replace(/\D/g, '');
      var currentValueDigits = this.state.formattedNumber.replace(/\D/g, '');

      if (nextProps.value && nextValueDigits !== currentValueDigits) {
        this.setState(this._mapPropsToState(nextProps));
      }
    }
  },
  _cursorToEnd: function _cursorToEnd() {
    var input = this.numberInputRef.current;

    if (input) {
      input.focus();
    }
  },
  formatSimpleNumber: function formatSimpleNumber(number) {
    var hasSelectedValidCountry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var digitsOnly = number.replace(/\D/g, '');

    if (!hasSelectedValidCountry) {
      return digitsOnly;
    }

    return "+" + digitsOnly;
  },
  handlePhoneNumberInput: function handlePhoneNumberInput(event) {
    var _this$state = this.state,
        formattedNumber = _this$state.formattedNumber,
        selectedCountry = _this$state.selectedCountry;
    var extension = this.props.extensionValue;
    var eventTarget = event.target;

    if (eventTarget.value === formattedNumber) {
      return;
    }

    var inputNumber = eventTarget.value.replace(/\D/g, '');

    if (inputNumber.indexOf(selectedCountry.dialCode) !== 0) {
      inputNumber = selectedCountry.dialCode;
    }

    if (this.props.onChange) {
      this.props.onChange({
        phoneNumber: this.formatSimpleNumber(inputNumber, selectedCountry.dialCode),
        extension: extension,
        country: selectedCountry.iso2
      });
    }

    var selectionStart = eventTarget.selectionStart;
    var formattedInputNumber = (0, _formatPhoneNumber.default)(inputNumber, selectedCountry.format);
    this.setState({
      formattedNumber: formattedInputNumber
    }, function () {
      var newSelectionStart = selectionStart;

      if (inputNumber === selectedCountry.dialCode || selectionStart === formattedNumber.length + 1) {
        newSelectionStart = formattedInputNumber.length + 1;
      }

      eventTarget.selectionStart = newSelectionStart;
      eventTarget.selectionEnd = newSelectionStart;
    });
  },
  handleExtensionInput: function handleExtensionInput(e) {
    var _this$state2 = this.state,
        selectedCountry = _this$state2.selectedCountry,
        formattedNumber = _this$state2.formattedNumber;
    this.props.onChange({
      phoneNumber: this.formatSimpleNumber(formattedNumber, selectedCountry.dialCode),
      extension: e.target.value.replace(/\D/g, ''),
      country: selectedCountry.iso2
    });
  },
  handleFlagItemClick: function handleFlagItemClick(e) {
    var _this = this;

    var extension = this.props.extensionValue;
    var _this$state3 = this.state,
        selectedCountry = _this$state3.selectedCountry,
        formattedNumber = _this$state3.formattedNumber;
    var nextSelectedCountry = allCountries[iso2Lookup[e.target.value]];

    if (selectedCountry.iso2 !== nextSelectedCountry.iso2) {
      var newNumber = selectedCountry.dialCode ? formattedNumber.replace(/\D/g, '').replace(selectedCountry.dialCode, nextSelectedCountry.dialCode) : "" + nextSelectedCountry.dialCode + formattedNumber;
      var newFormattedNumber = (0, _formatPhoneNumber.default)(newNumber, nextSelectedCountry.format);
      this.setState({
        selectedCountry: nextSelectedCountry,
        formattedNumber: newFormattedNumber
      }, function () {
        _this._cursorToEnd();

        if (_this.props.onChange) {
          _this.props.onChange({
            phoneNumber: _this.formatSimpleNumber(newNumber, selectedCountry.dialCode || nextSelectedCountry.dialCode),
            extension: extension,
            country: nextSelectedCountry.iso2
          });
        }
      });
    }
  },
  _mapPropsToState: function _mapPropsToState(props) {
    var inputNumber;

    if (props.value) {
      inputNumber = props.value;
    } else {
      inputNumber = '';
    }

    var selectedCountryGuess = INVALID_OPTION;
    var formattedNumber = inputNumber;

    if (inputNumber === '' || inputNumber.indexOf('+') === 0) {
      selectedCountryGuess = (0, _guessCountryFromDialCode.default)(inputNumber.replace(/\D/g, ''));
      var numberToFormat = inputNumber ? inputNumber.replace(/\D/g, '') : selectedCountryGuess.dialCode;
      formattedNumber = (0, _formatPhoneNumber.default)(numberToFormat, selectedCountryGuess.format);
    }

    return {
      selectedCountry: selectedCountryGuess,
      formattedNumber: formattedNumber
    };
  },
  getCountryDropDownList: function getCountryDropDownList(hasSelectedValidCountry, validCountries, supportedCountrySet) {
    var countryDropDownList = (0, _getPhoneOptions.default)(allCountries);

    var checkSupportedCountries = function checkSupportedCountries(country) {
      return _SupportedPhoneNumbers.default[supportedCountrySet].indexOf(country.value) >= 0;
    };

    var checkValidCountries = function checkValidCountries(country) {
      return validCountries.indexOf(country.value) >= 0;
    };

    if (supportedCountrySet && validCountries) {
      countryDropDownList = countryDropDownList.filter(function (country) {
        return checkSupportedCountries(country) && checkValidCountries(country);
      });
    } else if (supportedCountrySet) {
      countryDropDownList = countryDropDownList.filter(checkSupportedCountries);
    } else if (validCountries) {
      countryDropDownList = countryDropDownList.filter(checkValidCountries);
    }

    if (!hasSelectedValidCountry) {
      return [{
        value: INVALID_OPTION.iso2,
        text: _I18n.default.text('i18nAddon.countryInfo.invalidCountryOption')
      }].concat((0, _toConsumableArray2.default)(countryDropDownList));
    }

    return countryDropDownList;
  },
  buildValueRenderer: function buildValueRenderer(countryIso) {
    return function () {
      if (!countryIso) {
        return _react.default.createElement(_UIIcon.default, {
          name: "warning"
        });
      }

      return _react.default.createElement(_CountryFlag.default, {
        countryCode: countryIso
      });
    };
  },
  renderExtension: function renderExtension(extensionValue, extensionInputProps) {
    if (typeof extensionValue !== 'string') {
      return null;
    }

    return _react.default.createElement(_UITextInput.default, (0, _extends2.default)({}, extensionInputProps, {
      className: (0, _classnames.default)('extension-input', extensionInputProps.className),
      placeholder: _I18n.default.text('i18nAddon.phoneNumberInput.extensionPlaceholder'),
      onChange: this.handleExtensionInput,
      value: extensionValue
    }));
  },
  render: function render() {
    var _this$state4 = this.state,
        selectedCountry = _this$state4.selectedCountry,
        formattedNumber = _this$state4.formattedNumber;
    var _this$props = this.props,
        className = _this$props.className,
        countrySelectProps = _this$props.countrySelectProps,
        extensionInputProps = _this$props.extensionInputProps,
        extensionValue = _this$props.extensionValue,
        phoneInputProps = _this$props.phoneInputProps,
        __onChange = _this$props.onChange,
        validCountries = _this$props.validCountries,
        supportedCountrySet = _this$props.supportedCountrySet,
        passThroughProps = (0, _objectWithoutProperties2.default)(_this$props, ["className", "countrySelectProps", "extensionInputProps", "extensionValue", "phoneInputProps", "onChange", "validCountries", "supportedCountrySet"]);
    this.numberInputRef = this.numberInputRef || _react.default.createRef();
    return _react.default.createElement("div", (0, _extends2.default)({}, passThroughProps, {
      className: (0, _classnames.default)('phone-number-input', className)
    }), _react.default.createElement(_UISelect.default, (0, _extends2.default)({}, countrySelectProps, {
      className: (0, _classnames.default)('country-select', countrySelectProps.className),
      dropdownClassName: (0, _classnames.default)('country-dropdown', countrySelectProps.dropdownClassName),
      onChange: this.handleFlagItemClick,
      options: this.getCountryDropDownList(selectedCountry.dialCode, validCountries, supportedCountrySet),
      value: selectedCountry.iso2,
      valueRenderer: this.buildValueRenderer(selectedCountry.iso2)
    })), _react.default.createElement(_UITextInput.default, (0, _extends2.default)({}, phoneInputProps, {
      className: (0, _classnames.default)('phone-text-input', phoneInputProps.className),
      inputRef: this.numberInputRef,
      onChange: this.handlePhoneNumberInput,
      value: formattedNumber
    })), this.renderExtension(extensionValue, extensionInputProps));
  }
});

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-i18n/static-1.3462/js/components/PhoneNumberInput.js
// module id = 628
// module chunks = 5 6